module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_6.2a13e60a.png";